import { useTranslation } from 'react-i18next';
import { useScrollReveal } from '@/hooks/useScrollReveal';

const problemes = [
  { key: 'probleme_1', icon: 'ri-drop-line' },
  { key: 'probleme_2', icon: 'ri-windy-line' },
  { key: 'probleme_3', icon: 'ri-shape-line' },
  { key: 'probleme_4', icon: 'ri-haze-line' },
  { key: 'probleme_5', icon: 'ri-snowy-line' },
  { key: 'probleme_6', icon: 'ri-focus-3-line' },
];

export default function Problemes() {
  const { t } = useTranslation('reparation');
  const { ref, isVisible } = useScrollReveal<HTMLElement>(0.1);

  return (
    <section ref={ref} id="problemes" className="bg-white py-16 md:py-24">
      <div className="max-w-6xl mx-auto px-4 md:px-6 lg:px-10">
        <div
          className={`text-center mb-12 md:mb-16 transition-all duration-1000 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
        >
          <h2 className="font-manrope font-bold text-slate-primary text-2xl md:text-3xl lg:text-4xl mb-4">
            {t('problemes_h2')}
          </h2>
        </div>

        {/* Image banner */}
        <div
          className={`rounded-xl overflow-hidden mb-10 md:mb-14 transition-all duration-1000 delay-100 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
        >
          <img
            src="https://readdy.ai/api/search-image?query=Close-up%20of%20damaged%20roof%20shingles%20with%20water%20leak%20and%20ice%20dam%20on%20a%20Quebec%20house%20in%20winter%2C%20visible%20cracks%20and%20missing%20pieces%2C%20snow%20accumulation%20on%20edges%2C%20dramatic%20overcast%20lighting%20showing%20the%20urgency%20of%20repair%2C%20professional%20inspection%20photography%2C%20no%20text%20visible&width=1000&height=350&seq=rep-prob1&orientation=landscape"
            alt="Toiture endommagée avec infiltration d'eau et glace nécessitant réparation urgente à Lévis par couvreur RBQ"
            className="w-full h-48 md:h-64 object-cover object-top"
            loading="lazy"
            width="1000"
            height="350"
          />
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {problemes.map((p, idx) => (
            <div
              key={idx}
              className={`group bg-soft-gray rounded-xl p-5 md:p-6 border border-transparent hover:border-copper/30 transition-all duration-500 hover:-translate-y-1 ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
              }`}
              style={{ transitionDelay: `${idx * 100 + 200}ms` }}
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-copper/10 mb-4 group-hover:bg-copper/20 transition-colors">
                <i className={`${p.icon} text-copper text-xl`} />
              </div>
              <h3 className="font-manrope font-bold text-slate-primary text-base md:text-lg mb-2">
                {t(`${p.key}_title`)}
              </h3>
              <p className="text-slate-primary/60 text-sm leading-relaxed">
                {t(`${p.key}_desc`)}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}